/**
 * Podcasts Module
 *
 * @module Podcasts
 * @author EN GARDE, matthias
 * @version 2.0
 *
 * @requires jQuery
 *
 * change log:
 *    1.0        initial version (wavesurfer)
 *    2.0        switched from wavesurfer to Audio API
 */

var EN = EN || {};

EN.Podcasts = (function ($) {
    'use strict';

    //Only single class names are allowed for selectors... could be worked on..
    var options = {
        selectors: {
            detailsDate: '.en-mdl-prd-podcasts__detailsdate',
            detailsHeading: '.en-mdl-prd-podcasts__detailsheading',
            detailsText: '.en-mdl-prd-podcasts__detailstext',
            detailsDownload: '.en-mdl-prd-podcasts__detailsdownload',
            detailsThumbnail: '.en-mdl-prd-podcasts__detailsthumbnail',
            listItem: '.en-mdl-prd-podcasts__listitem',
            playpause: '.en-mdl-prd-podcasts__listiconplay',
            listtitle: '.en-mdl-prd-podcasts__listtitle'

        }
    };
    var podcastArray = [];
    var currentIndex;

    var init = function (settings) {
        //Allow settings override
        $.extend(true, options, settings);

        var $podcastItems = $(options.selectors.listItem);
        if ($podcastItems.length === 0) {
            return;
        }

        $podcastItems.each(function (index) {
            var $this = $(this);
            podcastArray[index] = {};
            podcastArray[index].loaded = false;
            podcastArray[index].canplay = false;
            podcastArray[index].audiofile = $this.data('audiofile');
            podcastArray[index].thumbnail = $this.data('thumbnail');
            podcastArray[index].heading = $this.data('heading');
            podcastArray[index].date = $this.data('date');
            podcastArray[index].text = $this.data('text');
            podcastArray[index].audio = $this.find('audio');
            podcastArray[index].waveform = $this.find('.en-mdl-prd-podcasts__waveform__inner');
            podcastArray[index].audioElement = $this.find('audio').get(0);
            podcastArray[index].listTitle = $this.find('.en-mdl-prd-podcasts__listtitle');


            //Add click handler to item row
            $this.on('click', handlePodcastItemClick);
        });

    } /* end of init */

    var handlePodcastItemClick = function (el) {
        var clickedElIndex = parseInt(el.currentTarget.dataset.index);

        //If the pause button was clicked on the current playing element, just remove the --playing state class, pause and return... nothing more to do
        if ($(el.target).hasClass(options.selectors.playpause.replace(/\./g, '')) && $(el.currentTarget).hasClass(options.selectors.listItem.replace(/\./g, '') + '--playing')) {
            $(el.currentTarget).removeClass(options.selectors.listItem.replace(/\./g, '') + '--playing');
            podcastArray[clickedElIndex].audioElement.pause();
            return;
        }

        //If the play button was clicked on the current active Element, just add the --playing state class, play and return... nothing more to do
        if ($(el.target).hasClass(options.selectors.playpause.replace(/\./g, '')) && $(el.currentTarget).hasClass(options.selectors.listItem.replace(/\./g, '') + '--active')) {
            addStateCssClass(clickedElIndex, 'playing');
            podcastArray[clickedElIndex].audioElement.play();
            return;
        }

        //Remove State CSS Classes
        $(options.selectors.listItem).removeClass(options.selectors.listItem.replace(/\./g, '') + '--active ' + options.selectors.listItem.replace(/\./g, '') + '--playing');

        podcastArray.forEach(function (podcast, index) {
            //If other podcasts are playing, pause them
            if (!podcast.audioElement.paused && index !== clickedElIndex) {
                podcast.audioElement.pause();
            }
        });
        addStateCssClass(clickedElIndex, 'playing');
        addStateCssClass(clickedElIndex, 'active');

        //If clicked element is not already loaded, add an event listener that sets loaded to true and plays the entry then load the item
        if (podcastArray[clickedElIndex].loaded === false) {
            podcastArray[clickedElIndex].audioElement.load();
            podcastArray[clickedElIndex].listTitle.text("loading ...");
            podcastArray[clickedElIndex].audio.on("canplaythrough", function () {
                podcastArray[clickedElIndex].canplay = true;
                podcastArray[clickedElIndex].listTitle.html(podcastArray[clickedElIndex].heading);
            });
            podcastArray[clickedElIndex].audio.on("timeupdate", function () {
                var audioElement = podcastArray[clickedElIndex].audioElement;
                var playedPercent = (audioElement.currentTime / audioElement.duration) * 100;
                podcastArray[clickedElIndex].waveform.css("width", parseInt(playedPercent) + "%")
            });
            podcastArray[clickedElIndex].loaded = true;
        }

        if (currentIndex !== clickedElIndex) {
            podcastArray[clickedElIndex].audioElement.play();
            setDetails(clickedElIndex);
            currentIndex = clickedElIndex;
        } else if (podcastArray[clickedElIndex].canplay) {
            var percentClicked = ((el.pageX - $(this).parent().offset().left) / $(this).width()) * 100;
            podcastArray[currentIndex].audioElement.currentTime = podcastArray[currentIndex].audioElement.duration / 100 * percentClicked;
        }

    }

    var setDetails = function (clickedElIndex) {
        $(options.selectors.detailsDate).hide().html(podcastArray[clickedElIndex].date).fadeIn(500);
        $(options.selectors.detailsHeading).hide().html(podcastArray[clickedElIndex].heading).fadeIn(500);
        $(options.selectors.detailsText).hide().html(podcastArray[clickedElIndex].text).fadeIn(500);
        $(options.selectors.detailsThumbnail).hide().attr('src', podcastArray[clickedElIndex].thumbnail).fadeIn(500);
        $(options.selectors.detailsDownload).attr('href', podcastArray[clickedElIndex].audiofile);
    }

    var addStateCssClass = function (clickedElIndex, state) {
        $(options.selectors.listItem + ':eq(' + clickedElIndex + ')').addClass(options.selectors.listItem.replace(/\./g, '') + '--' + state);
    }

    return {
        init: init
    };
}(jQuery));